module.exports = __webpack_public_path__ + "static/media/massHangingFromStringsProblem1.8ff2f387.svg";